import { TableViewOutlined } from '@mui/icons-material';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import { Box, Button, Typography } from '@mui/material';
import { RiFileExcel2Fill } from 'react-icons/ri';

import { Block } from 'components/page';
import { useDownloadFile } from 'hooks/useDownloadFile';

export function LojaReport() {
    const { isLoadingFile, downloadFile } = useDownloadFile({
        requestOptions: {
            url: '/gestao/lojaconfiguracao/exportar',
        },
    });

    return (
        <Block
            sx={{
                display: 'flex',
                flex: 1,
                gap: 2,
                margin: 0,
                marginTop: { xs: 2, lg: 0 },
                alignItems: 'center',
                flexDirection: { xs: 'column', sm: 'row' },
            }}
        >
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                <TableViewOutlined color="primary" />

                <Typography>EXPORTAR CADASTRO DE LOJAS</Typography>

                <ChevronRightOutlinedIcon color="primary" />
            </Box>

            <Button
                variant="outlined"
                onClick={() => downloadFile({ directDownload: true })}
                loading={isLoadingFile}
                startIcon={<RiFileExcel2Fill />}
                sx={{ color: 'green', borderColor: 'green', width: { xs: '100%', sm: 'auto' } }}
            >
                Exportar em .xlsx
            </Button>
        </Block>
    );
}
